import { generatePath } from 'react-router-dom'
import { GridColumnProps } from '@progress/kendo-react-grid'
import { TicketDto, TicketKey } from 'api/Tickets/Types/TicketDto'
import { Link } from 'components/Link'
import { links } from 'utils/featureToggles'

import { ticketsColumn } from './ticketsColumn'

interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const leadColumn: GridColumn = {
  title: 'Lead',
  field: TicketKey.LEAD,
  cell: (gridCellProps) => {
    const lead = (gridCellProps.dataItem as TicketDto).lead
    if (!lead) {
      return <td />
    }
    return (
      <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
        <Link
          to={{
            pathname: generatePath(links.recordsLeads.detailsUrl as string, {
              id: lead.id,
              slug: 'details',
            }),
          }}
          data-test='lead-link'
        >
          {lead.name}
        </Link>
      </td>
    )
  },
  filter: 'boolean',
  show: true,
  filterable: true,
  sortable: false,
}

const ColumnPositionIndex = 1 as const

export const ticketsSalesColumns = (): GridColumn[] => {
  const columns = addColumnAtPosition(ticketsColumn)(ColumnPositionIndex)
  return columns.filter(filterDescriptionColumn).filter(filterActionColumn)
}

const filterDescriptionColumn = (column: GridColumn) => {
  return column.field !== TicketKey.DESCRIPTION
}

const filterActionColumn = (column: GridColumn) => {
  return column.field !== TicketKey.action
}

const addColumnAtPosition =
  (columns: GridColumn[]) =>
  (positionIndex: number): GridColumn[] => {
    return columns.reduce((previousValue: GridColumn[], currentValue: GridColumn, currentIndex) => {
      return currentIndex === positionIndex
        ? [...previousValue, currentValue, leadColumn]
        : [...previousValue, currentValue]
    }, [])
  }
